module.exports = __webpack_public_path__ + "static/media/reception.0f7a7f23.png";